import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HelmetProvider } from 'react-helmet-async'; // 1. Yeh line add karein

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider> {/* 2. App ko isse wrap karein */}
      <App />
    </HelmetProvider>
  </React.StrictMode>
);